var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_242_5110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.43707 6.11047H11.0045",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1467 6.39761V9.15303C10.1467 9.33572 10.0409 9.51093 9.85249 9.64012C9.6641 9.7693 9.40858 9.84188 9.14215 9.84188H3.11468C2.84825 9.84188 2.59274 9.7693 2.40434 9.64012C2.21595 9.51093 2.11011 9.33572 2.11011 9.15303V6.39761",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.39288 4.19708L10.0468 2.2836",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.71765 3.61358L4.50238 2.74773C4.47154 2.62586 4.46502 2.4991 4.48319 2.37471C4.50137 2.25031 4.54388 2.13072 4.6083 2.02276C4.67271 1.91481 4.75778 1.8206 4.85862 1.74554C4.95947 1.67048 5.07412 1.61602 5.19602 1.5853L6.12406 1.35568C6.24625 1.32491 6.37332 1.31859 6.49797 1.33707C6.62261 1.35555 6.74238 1.39847 6.85039 1.46336C6.9584 1.52826 7.05253 1.61385 7.12737 1.71523C7.20221 1.8166 7.25629 1.93176 7.2865 2.0541L7.50177 2.91516",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4809,
    height: 11.4809,
    fill: "white",
    transform: "translate(0.479858 0.370239)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookTimeIcon);
export default __webpack_public_path__ + "static/media/CookTimeIcon.5048b109a3364946e8c1e3f38263b66c.svg";
export { ForwardRef as ReactComponent };